document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.rwl-mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})});
document.addEventListener('click',event=>{document.querySelectorAll('.rwl-mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false})});
document.addEventListener('shopify:section:load',()=>{document.querySelectorAll('.rwl-mobile-menu[open]').forEach(menu=>menu.open=false)});
function openQuestion(){if(!location.hash)return;const target=document.getElementById(decodeURIComponent(location.hash.slice(1)));if(target?.matches('.rwl-faq-disclosure')){target.open=true;target.scrollIntoView({block:'center'})}}
window.addEventListener('hashchange',openQuestion);openQuestion();

// Distinct page destinations, immediate selection feedback, and a reading-position indicator.
function initProductNavigation(){
  const nav=document.querySelector('.rwl-product-nav');
  if(!nav||nav.dataset.initialized)return;
  nav.dataset.initialized='true';
  const items=[...nav.querySelectorAll('a[href^="#"]')].map(link=>({link,target:document.getElementById(link.hash.slice(1))})).filter(item=>item.target);
  let lockedUntil=0,frame=0;
  function select(item){items.forEach(candidate=>{if(candidate===item)candidate.link.setAttribute('aria-current','location');else candidate.link.removeAttribute('aria-current')})}
  function update(){
    frame=0;if(Date.now()<lockedUntil)return;
    const line=nav.getBoundingClientRect().height+Math.min(innerHeight*.2,140);
    let current=items[0];
    items.forEach(item=>{if(item.target.getBoundingClientRect().top<=line)current=item});
    if(current)select(current);
  }
  items.forEach(item=>item.link.addEventListener('click',event=>{
    event.preventDefault();lockedUntil=Date.now()+1100;select(item);
    if(location.hash!==item.link.hash)history.pushState(null,'',item.link.hash);
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches||document.body.classList.contains('rwl-no-motion');
    item.target.focus({preventScroll:true});
    item.target.scrollIntoView({behavior:reduced?'instant':'smooth',block:'start'});
    item.target.classList.remove('rwl-arrival');void item.target.offsetWidth;item.target.classList.add('rwl-arrival');
  }));
  addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update)},{passive:true});
  addEventListener('resize',update);
  addEventListener('popstate',()=>{lockedUntil=0;requestAnimationFrame(update)});
  update();
}
initProductNavigation();
document.addEventListener('shopify:section:load',initProductNavigation);

// Hero videos respect the visitor's reduced-motion preference.
document.querySelectorAll('.rwl-campaign-video').forEach(video=>{
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||document.body.classList.contains('rwl-no-motion'))video.pause();
});
